export const base64ToBlob: (data: string, type: null | "png" | "jpg" | "docx" | "pdf") => { success: boolean, file: Blob | null } = (data, type) => {
    const arrMimyTypes = ['application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'image/png', 'image/jpg']

    // Cut the prefix `data:type/subtype;base64,` from the raw base 64, if present
    let base64WithoutPrefix = data;
    for (let index = 0; index < arrMimyTypes.length; index++) {
        const mimeName = arrMimyTypes[index];
        if (!!data.includes(mimeName)) {
            base64WithoutPrefix.substring(('data:' + mimeName + ';base64,').length);
            break;
        }
    }

    const bytes = window.atob(base64WithoutPrefix);
    let length = bytes.length;
    let out = new Uint8Array(length);

    while (length--) {
        out[length] = bytes.charCodeAt(length);
    }

    let prefixType = null;
    if (type === 'pdf') {
        prefixType = 'application/pdf';
    } else if (type === 'docx') {
        prefixType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    } else if (type === 'png') {
        prefixType = 'image/png';
    } else if (type === 'jpg') {
        prefixType = 'image/jpg';
    }

    return {
        success: prefixType !== null,
        file: prefixType !== null ? (new Blob([out], { type: prefixType })) : null
    }
};